'use es6';

import PropTypes from 'prop-types';
import { omit } from 'rich-text-lib/utils/iterables';
import { useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default function InsertButton(props) {
  const [isActive, setIsActive] = useState(false);
  const handleNodeChange = evt => {
    const isActiveHandler = props.isActiveHandler(evt);
    if (isActiveHandler !== isActive) {
      setIsActive(isActiveHandler);
    }
  };
  const handleClick = () => {
    props.onClick({
      isActive
    });
  };
  useEffect(() => {
    const {
      editor,
      onClickShortcut
    } = props;

    // @TODO: Remove this in support of the omnipotent NodeChange handler
    editor.on('NodeChange', handleNodeChange);
    if (onClickShortcut) {
      editor.shortcuts.add(onClickShortcut, '', handleClick);
    }
    return () => {
      editor.off('NodeChange', handleNodeChange);
      if (onClickShortcut) {
        editor.shortcuts.remove(onClickShortcut);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const buttonProps = omit(Object.keys(InsertButton.propTypes), props);
  const {
    ButtonComponent,
    tooltip,
    i18nKey
  } = props;
  return /*#__PURE__*/_jsx(ButtonComponent, Object.assign({
    onClick: handleClick,
    selected: isActive,
    tooltip: tooltip || i18nKey(`tooltip.${isActive ? 'edit' : 'insert'}`)
  }, buttonProps));
}
InsertButton.propTypes = {
  ButtonComponent: PropTypes.object.required,
  editor: PropTypes.object.isRequired,
  isActiveHandler: PropTypes.func.isRequired,
  tooltip: PropTypes.string,
  i18nKey: PropTypes.func,
  onClick: PropTypes.func.isRequired,
  onClickShortcut: PropTypes.string
};
InsertButton.defaultProps = {
  isActiveHandler: () => false
};